<template>
	<div class="paper">
		<div class="paper-content">
			
			<transition-group name="phases" tag="div" class="phases">
				<phase v-for="(phase, index) in last_phases" :key="phase.id" :phase="phase" :position="index" />
			</transition-group>

			<div v-if="active_phase && active_phase.type != 'lose'" class="prompt"><icon file="chevron-right" :size="32" />{{ game.prompt }}</div>

			<transition name="error">
				<div v-show="game.error.active" class="error">{{ game.error.text }}</div>
			</transition>

		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Phase from './Phase'

export default {
	name: 'Paper',
	data () {
		return {

		}
	},
	computed: Object.assign(mapGetters([ 'game', 'active_phase' ]), {
		last_phases: function() {
			return _.takeRight(this.game.phases, 5)
		}
	}),
	components: { Phase }
}
</script>

<style lang="stylus">
@import '../assets/css/app'


.phases-enter-active, .phases-move
	transition 0.5s easeOutQuart
.phases-enter
	opacity 0
	transform translate3D(0, 100%, 0)


.paper
	background #fff
	font-family 'Averia Libre', 'Inconsolata'
	padding 48px 48px 32px 48px
	display flex
	flex-direction column
	justify-content flex-end
	font-size 28px
	line-height 32px
	color dark
	overflow hidden
	&.paper-enter-active, &.paper-leave-active
		transition 0.5s easeOutQuart
		.phase
			transition 0s
	&.paper-leave-to
		transform translate3D(0, -1000px, 0)
	&.paper-enter
		transform translate3D(0, 100%, 0)
		.phase
			transform none
	.paper-content
		.prompt
			margin 32px 0 0 0
			height 32px
			line-height calc(@height - 2px)
			.icon
				display none
				float left
				margin 1px 4px 0 0
		.error
			position absolute
			left 0
			bottom -24px
			line-height 24px
			color red
			font-size 16px
			&.error-enter-active
				transition 0.15s easeOutQuart
			&.error-leave-active
				transition 0.35s easeOutQuart
			&.error-leave-to, &.error-enter
				opacity 0
				transform translate3D(0, 200%, 0)

</style>



// WEBPACK FOOTER //
// src/components/Paper.vue